<template>
  <nav>
    <div class="bg-light-gray">
      <div class="flex justify-between p-2 sm:container">
        <div class="flex shrink-0 grow items-center justify-start lg:hidden">
          <MenuButton
            @click="toggleOpen"
            @keyboard.enter.prevent="toggleOpen(true)"
            @keyboard.space.prevent="toggleOpen(true)"
            :isOpen="isOpen">
          </MenuButton>
        </div>
        <div
          class="grow-2 lg-max:mx-2 lg:grow-1 flex w-[236px] shrink-0 items-center justify-center lg:justify-start">
          <Link href="/" aria-label="Retire path logo link to home page">
            <svg
              class="h-full max-h-10 w-full"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xml:space="preserve"
              viewBox="0 0 303 51.4"
              title="Retire path logo">
              <defs><path id="a" d="M0 0h303v51.4H0z" /></defs>
              <clipPath id="b">
                <use xlink:href="#a" overflow="visible" />
              </clipPath>
              <g clip-path="url(#b)">
                <text
                  fill="#003a70"
                  font-family="Helvetica"
                  font-size="5"
                  transform="translate(293.192 4.351)">
                  SM
                </text>
              </g>
              <path
                fill="#003a70"
                d="m278.5.8 10.6 27.5h-5l-2.8 7.9H303L289.6.8h-11.1z" />
              <path
                fill="#e67300"
                d="m266 34.8-5.5 15h11l18-48.9h-11.4L266 34.8z" />
              <path
                fill="#003a70"
                d="M260.5 49.8h11.1L258 14.4h-10.9l13.4 35.4z" />
              <g>
                <defs><path id="c" d="M0 0h303v51.4H0z" /></defs>
                <clipPath id="d">
                  <use xlink:href="#c" overflow="visible" />
                </clipPath>
                <g clip-path="url(#d)">
                  <path
                    fill="#003a70"
                    d="M7.4 39.2H0V14.4h7.4v6c1.3-4.6 4.5-6.5 7-6.5 1.5 0 2.9.3 4.3.9l-1.3 6.6c-1.2-.5-2.5-.8-3.8-.7-4.3 0-6.2 3.3-6.2 9.9v8.6zM44.2 34.7c-2.5 3.7-7.1 5-11.3 5-7 .2-12.8-5.3-13-12.3v-.7c0-7.8 5.8-12.9 13-12.9 7.1 0 12.7 5.3 12.7 13.1 0 .6-.1 1.6-.1 2.3H27.3c.4 2.9 3.5 4.1 6.1 4.1 2.1.1 4.1-.8 5.4-2.3l5.4 3.7zm-6.1-10.1c-.4-2.5-2.6-4.4-5.2-4.3-2.6-.1-5 1.7-5.5 4.3h10.7zM64.6 14.4v5.8h-5.2v19H52v-19h-4.5v-5.8H52V4.9h7.3v9.5h5.3zM68.6 14.4H76v24.8h-7.3V14.4zM89.4 39.2H82V14.4h7.4v6c1.3-4.6 4.5-6.5 7-6.5 1.5 0 2.9.3 4.3.9l-1.3 6.6c-1.2-.5-2.5-.8-3.8-.7-4.3 0-6.2 3.3-6.2 9.9v8.6zM126.2 34.7c-2.5 3.7-7.1 5-11.3 5-7 .2-12.8-5.3-13-12.3v-.7c0-7.8 5.8-12.9 13-12.9 7.1 0 12.7 5.3 12.7 13.1 0 .6-.1 1.6-.1 2.3h-18.2c.4 2.9 3.5 4.1 6.1 4.1 2.1.1 4.1-.8 5.4-2.3l5.4 3.7zm-6.1-10.1c-.4-2.5-2.6-4.4-5.2-4.3-2.6-.1-5 1.7-5.5 4.3h10.7z" />
                  <path
                    fill="#e67300"
                    d="M141.5 14.4v3.1c1.2-2.3 4.2-3.6 7.3-3.6 6.4 0 12 5 12 12.9 0 8-5.6 13-12 13-3.1 0-6.1-1.3-7.3-3.6v15.2h-7.3v-37h7.3zm5.9 18.4c3.1 0 5.7-2.4 5.7-5.6v-.3c.2-3.1-2.2-5.8-5.4-6h-.4c-3.2 0-5.8 2.6-5.7 5.8v.2c-.2 3.1 2.2 5.7 5.3 5.9h.5M183.8 36.4c-1.6 2.4-5.3 3.3-7.2 3.3-7 0-12.7-5.7-12.7-12.7v-.2c-.1-7 5.4-12.8 12.4-12.9h.2c1.6 0 5.3.5 7.2 3.3v-2.8h7.3v24.8h-7.3v-2.8zm-6.1-3.7c3.3 0 5.9-2.6 5.9-5.9s-2.6-5.9-5.9-5.9c-3.3-.1-6.1 2.6-6.2 5.9.1 3.3 2.9 6 6.2 5.9M211.9 14.4v5.8h-5.2v19h-7.3v-19h-4.5v-5.8h4.5V4.9h7.3v9.5h5.2zM223.6 39.2h-7.4V.9h7.4v17.4c1-3.1 4.6-4.4 7-4.4 6.5 0 9.9 4.4 9.9 11.9v13.5h-7.4V26c.2-2.6-1.8-4.8-4.3-4.9h-.3c-2.3 0-4.9 1.3-4.9 5v13.1z" />
                </g>
              </g>
            </svg>
          </Link>
        </div>
        <div class="grow-2 hidden basis-full lg:mx-2 lg:block">
          <ul
            class="nav nav--desktop m-0 flex h-full list-none items-center justify-end space-x-2 px-0"
            ref="nav">
            <Dropdown
              :currentUrl="currentUrl"
              :links="dropdownLinks.employers"
              @exitMenu="menuKeyboardAction">
              Employers
            </Dropdown>
            <Dropdown
              :currentUrl="currentUrl"
              :links="dropdownLinks.savers"
              @exitMenu="menuKeyboardAction">
              Savers
            </Dropdown>
            <Dropdown
              :currentUrl="currentUrl"
              :links="dropdownLinks.espanol"
              @exitMenu="menuKeyboardAction">
              Español
            </Dropdown>
            <Dropdown
              :currentUrl="currentUrl"
              :links="dropdownLinks.resources"
              @exitMenu="menuKeyboardAction">
              Resources
            </Dropdown>
            <Dropdown
              :currentUrl="currentUrl"
              :links="dropdownLinks.contact"
              @exitMenu="menuKeyboardAction">
              Contact
            </Dropdown>
            <Dropdown
              :links="dropdownLinks.register"
              :type="'secondary'"
              @exitMenu="menuKeyboardAction">
              Register
            </Dropdown>
            <Dropdown
              :links="dropdownLinks.myAccount"
              :type="'primary'"
              @exitMenu="menuKeyboardAction">
              My Account
            </Dropdown>
          </ul>
        </div>
      </div>
    </div>
    <transition name="dropdown-fade">
      <div v-show="isOpen" class="nav nav--mobile">
        <div class="gap-20px mb-40px grid grid-cols-2 px-2">
          <a
            class="btn btn--secondary btn--nav"
            :href="'https://retirepathva.vestwell.com/'">
            Employer Login
          </a>
          <a
            class="btn btn--primary btn--nav"
            :href="'http://retirepathva.vestwell.com/register/employer'">
            Register Business
          </a>
          <a
            class="btn btn--secondary btn--nav"
            :href="'https://retirepathva.vestwell.com/'">
            Saver Login
          </a>
          <a
            class="btn btn--primary btn--nav"
            :href="'https://connect.vestwell.com/signup/retirepathva/retrieve'">
            Register Saver
          </a>
        </div>
        <nav class="px-2 pb-4">
          <ul class="nav__menu" ref="navMobile">
            <li class="nav__nav-item nav__nav-item--dropdown">
              <div class="nav__nav-link nav__nav-link--dropdown">Employers</div>
              <ul class="nav__menu nav__menu--dropdown">
                <NavItem
                  v-for="(link, index) in dropdownLinks.employers"
                  :key="index"
                  :url="link.link"
                  :currentUrl="currentUrl">
                  {{ link.label }}
                </NavItem>
              </ul>
            </li>
            <li class="nav__nav-item nav__nav-item--dropdown">
              <div class="nav__nav-link nav__nav-link--dropdown">Savers</div>
              <ul class="nav__menu nav__menu--dropdown">
                <NavItem
                  v-for="(link, index) in dropdownLinks.savers"
                  :key="index"
                  :url="link.link"
                  :currentUrl="currentUrl">
                  {{ link.label }}
                </NavItem>
              </ul>
            </li>
            <li class="nav__nav-item nav__nav-item--dropdown">
              <div class="nav__nav-link nav__nav-link--dropdown">Español</div>
              <ul class="nav__menu nav__menu--dropdown">
                <NavItem
                  v-for="(link, index) in dropdownLinks.espanol"
                  :key="index"
                  :url="link.link"
                  :currentUrl="currentUrl">
                  {{ link.label }}
                </NavItem>
              </ul>
            </li>
            <li class="nav__nav-item nav__nav-item--dropdown">
              <div class="nav__nav-link nav__nav-link--dropdown">Resources</div>
              <ul class="nav__menu nav__menu--dropdown">
                <NavItem
                  v-for="(link, index) in dropdownLinks.resources"
                  :key="index"
                  :url="link.link"
                  :currentUrl="currentUrl">
                  {{ link.label }}
                </NavItem>
              </ul>
            </li>
            <li class="nav__nav-item nav__nav-item--dropdown">
              <div class="nav__nav-link nav__nav-link--dropdown">Contact</div>
              <ul class="nav__menu nav__menu--dropdown">
                <NavItem
                  v-for="(link, index) in dropdownLinks.contact"
                  :key="index"
                  :url="link.link"
                  :currentUrl="currentUrl">
                  {{ link.label }}
                </NavItem>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </transition>
  </nav>
</template>

<script>
import MenuButton from "../Atoms/MenuButton.vue";
import SearchButton from "../Atoms/SearchButton.vue";
import Button from "../Atoms/Button.vue";
import NavItem from "./Components/NavItem.vue";
import Dropdown from "./Components/Dropdown.vue";
import { ref, nextTick } from "vue";
import { Link } from "@inertiajs/vue3";

export default {
  components: {
    Button,
    Dropdown,
    Link,
    MenuButton,
    NavItem,
    SearchButton,
  },

  props: {
    currentUrl: {
      type: String,
    },
    siteUrl: {
      type: String,
    },
  },

  setup() {
    const isOpen = ref(false);
    const isOpenDropdown = ref(false);
    const nav = ref(null);
    const navMobile = ref(null);
    let focusedIndex = 0;
    const dropdownLinks = {
      employers: [
        {
          label: "Employer Details",
          link: "/employers",
        },
        {
          label: "Payroll Providers",
          link: "/employers/payroll-providers",
        },
        {
          label: "Eligibility Quiz",
          link: "/employers/quiz",
        },
      ],
      savers: [
        {
          label: "Savers Details",
          link: "/savers",
        },
        {
          label: "Contributions",
          link: "/savers/contributions",
        },
        {
          label: "Investments",
          link: "/savers/investments",
        },
        {
          label: "Withdrawals",
          link: "/savers/withdrawals",
        },
        {
          label: "Price & Performance",
          link: "/savers/price-performance",
        },
        {
          label: "Calculator",
          link: "/savers/calculator",
        },
      ],
      espanol: [
        {
          label: "Empleadores",
          link: "/espanol/empleadores",
        },
        {
          label: "Ahorradores",
          link: "/espanol/ahorradores",
        },
      ],
      resources: [
        {
          label: "About",
          link: "/resources/about",
        },
        {
          label: "FAQs",
          link: "/resources/faqs",
        },
        {
          label: "Docs & Forms",
          link: "/resources/documents",
        },
        {
          label: "Webinars",
          link: "/resources/webinars",
        },
        {
          label: "Financial Education",
          link: "/resources/financial-education",
        },
        {
          label: "News",
          link: "/resources/news",
        },
        {
          label: "Program Resources",
          link: "/resources/program-resources",
        },
      ],
      contact: [
        {
          label: "Contact Us",
          link: "/contact",
        },
        {
          label: "Subscribe",
          link: "/contact/subscribe",
        },
      ],
      register: [
        {
          label: "Saver Account",
          tag: "external",
          link: "https://connect.vestwell.com/signup/retirepathva/retrieve",
        },
        {
          label: "Employer Account",
          tag: "external",
          link: "http://retirepathva.vestwell.com/register/employer",
        },
      ],
      myAccount: [
        {
          label: "Saver Login",
          tag: "external",
          link: "https://retirepathva.vestwell.com/",
        },
        {
          label: "Employer Login",
          tag: "external",
          link: "https://retirepathva.vestwell.com/",
        },
      ],
    };

    const toggleOpen = async (focus) => {
      isOpen.value = !isOpen.value;

      if (focus && isOpen.value) {
        await nextTick();
        navMobile.value.children[focusedIndex].children[0].focus();
      }
    };

    const focusPrevious = (isArrowKey) => {
      focusedIndex = focusedIndex - 1;
      if (isArrowKey) {
        focusItem();
      }
    };

    const focusNext = (isArrowKey) => {
      focusedIndex = focusedIndex + 1;
      if (isArrowKey) {
        focusItem();
      }
    };

    const focusItem = () => {
      nav.value.children[focusedIndex].children[0].focus();
    };

    const menuKeyboardAction = (action) => {
      switch (action) {
        case "nextArrow":
          focusNext(true);
          break;

        case "previousArrow":
          focusPrevious(true);
          break;

        case "nextTab":
          focusNext(false);
          break;

        case "previousTab":
          focusPrevious(false);
          break;
      }
    };
    // const Links = {
    //   0: {
    //     name: 'Employers',
    //     url: '/employers',
    //     type: 'link'
    //   },
    // };
    return {
      isOpen,
      isOpenDropdown,
      nav,
      navMobile,
      focusNext,
      focusPrevious,
      menuKeyboardAction,
      toggleOpen,
      dropdownLinks,
    };
  },
};
</script>
